import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 96.853 77.483',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M93.221,29.056H72.64V3.632A3.631,3.631,0,0,0,69.008,0H47.216a3.631,3.631,0,0,0-3.632,3.632v10.9H33.9V2.421A2.421,2.421,0,0,0,31.477,0H29.056a2.421,2.421,0,0,0-2.421,2.421V14.528H16.949V2.421A2.421,2.421,0,0,0,14.528,0H12.107A2.421,2.421,0,0,0,9.685,2.421V14.528H3.632A3.631,3.631,0,0,0,0,18.16V72.64a4.843,4.843,0,0,0,4.843,4.843H92.011a4.843,4.843,0,0,0,4.843-4.843V32.688A3.632,3.632,0,0,0,93.221,29.056ZM19.371,61.139a1.816,1.816,0,0,1-1.816,1.816H11.5a1.816,1.816,0,0,1-1.816-1.816V55.085A1.816,1.816,0,0,1,11.5,53.269h6.053a1.816,1.816,0,0,1,1.816,1.816Zm0-14.528a1.816,1.816,0,0,1-1.816,1.816H11.5a1.816,1.816,0,0,1-1.816-1.816V40.557A1.816,1.816,0,0,1,11.5,38.741h6.053a1.816,1.816,0,0,1,1.816,1.816Zm0-14.528A1.816,1.816,0,0,1,17.555,33.9H11.5a1.816,1.816,0,0,1-1.816-1.816V26.029A1.816,1.816,0,0,1,11.5,24.213h6.053a1.816,1.816,0,0,1,1.816,1.816ZM38.741,61.139a1.816,1.816,0,0,1-1.816,1.816H30.872a1.816,1.816,0,0,1-1.816-1.816V55.085a1.816,1.816,0,0,1,1.816-1.816h6.053a1.816,1.816,0,0,1,1.816,1.816Zm0-14.528a1.816,1.816,0,0,1-1.816,1.816H30.872a1.816,1.816,0,0,1-1.816-1.816V40.557a1.816,1.816,0,0,1,1.816-1.816h6.053a1.816,1.816,0,0,1,1.816,1.816Zm0-14.528A1.816,1.816,0,0,1,36.925,33.9H30.872a1.816,1.816,0,0,1-1.816-1.816V26.029a1.816,1.816,0,0,1,1.816-1.816h6.053a1.816,1.816,0,0,1,1.816,1.816ZM62.955,46.611a1.816,1.816,0,0,1-1.816,1.816H55.085a1.816,1.816,0,0,1-1.816-1.816V40.557a1.816,1.816,0,0,1,1.816-1.816h6.053a1.816,1.816,0,0,1,1.816,1.816Zm0-14.528A1.816,1.816,0,0,1,61.139,33.9H55.085a1.816,1.816,0,0,1-1.816-1.816V26.029a1.816,1.816,0,0,1,1.816-1.816h6.053a1.816,1.816,0,0,1,1.816,1.816Zm0-14.528a1.816,1.816,0,0,1-1.816,1.816H55.085a1.816,1.816,0,0,1-1.816-1.816V11.5a1.816,1.816,0,0,1,1.816-1.816h6.053A1.816,1.816,0,0,1,62.955,11.5ZM87.168,61.139a1.816,1.816,0,0,1-1.816,1.816H79.3a1.816,1.816,0,0,1-1.816-1.816V55.085A1.816,1.816,0,0,1,79.3,53.269h6.053a1.816,1.816,0,0,1,1.816,1.816Zm0-14.528a1.816,1.816,0,0,1-1.816,1.816H79.3a1.816,1.816,0,0,1-1.816-1.816V40.557A1.816,1.816,0,0,1,79.3,38.741h6.053a1.816,1.816,0,0,1,1.816,1.816Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
